import { combineReducers } from 'redux'
import DefaultReducers from 'reducers'
const Reducer = combineReducers({ ...DefaultReducers })
export default Reducer